var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFastTransferIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 139.988,
    height: 119.99,
    viewBox: "0 0 139.988 119.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-speedometer",
    "data-name": "Icon ionic-ios-speedometer",
    d: "M72.244,4.5a69.971,69.971,0,0,0-52.4,116.365c.344.375.656.75,1,1.094a7.87,7.87,0,0,0,11.593-.031,54.1,54.1,0,0,1,79.618,0,7.87,7.87,0,0,0,11.593.031l1-1.094A69.971,69.971,0,0,0,72.244,4.5ZM67.87,18.843a4.375,4.375,0,0,1,8.749,0V30.092a4.375,4.375,0,0,1-8.749,0Zm-40,60H16.624a4.375,4.375,0,0,1,0-8.749H27.873a4.375,4.375,0,0,1,0,8.749ZM43.965,46.184h0a4.414,4.414,0,0,1-6.187,0L29.81,38.247a4.414,4.414,0,0,1,0-6.187h0a4.414,4.414,0,0,1,6.187,0l7.968,7.968A4.376,4.376,0,0,1,43.965,46.184Zm50.183,10.78L79.306,80.556a9.686,9.686,0,0,1-2.187,2.187A9.408,9.408,0,1,1,66.182,67.432L89.774,52.59a3.2,3.2,0,0,1,3.656,0A3.142,3.142,0,0,1,94.149,56.964Zm12.561-10.78a4.414,4.414,0,0,1-6.187,0h0a4.414,4.414,0,0,1,0-6.187l7.968-7.968a4.414,4.414,0,0,1,6.187,0h0a4.414,4.414,0,0,1,0,6.187Zm21.154,32.654H116.615a4.375,4.375,0,0,1,0-8.749h11.249a4.375,4.375,0,1,1,0,8.749Z",
    transform: "translate(-2.25 -4.5)",
    fill: "#1fbdfc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastTransferIcon);
export default __webpack_public_path__ + "static/media/fast-transfer-icon.9b13703fb86fd47adf795b69be5a0877.svg";
export { ForwardRef as ReactComponent };